import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import Create from './Create';
import Edit from './Edit';
import CustomDashboardLayout from './CustomDashboardLayout';
import DashboardContext from '../shared/hooks/dashboardContext';

export default function CustomDashboardRoutes(props) {
    function reloadPageTo(path) {
        window.location.href = `${window.location.origin}${props.baseName}${path}`;
    }

    return (
        <DashboardContext.Provider
            value={{
                assets: props.assets,
                customizations: props.customizations,
                favoriteUtilities: props.favoriteUtilities,
                menuUtilities: props.menuUtilities,
                uriConstants: props.uriConstants,
            }}
        >
            <Switch>
                <Route
                    path={`${props.path}/Create`}
                    render={({ history, location }) => (
                        <Create
                            dashboardConfiguration={JSON.parse(
                                location.state?.dashboardConfiguration ?? null
                            )}
                            history={history}
                            reloadPageTo={reloadPageTo}
                            selectedWidgetId={location.state?.selectedWidgetId}
                        />
                    )}
                />
                <Route
                    path={`${props.path}/:dashboardKey/Edit`}
                    render={({ history, location, match }) => (
                        <Edit
                            dashboardConfiguration={JSON.parse(
                                location.state?.dashboardConfiguration ?? null
                            )}
                            dashboardKey={match.params.dashboardKey}
                            hasPendingChanges={
                                location.state?.hasPendingChanges
                            }
                            history={history}
                            reloadPageTo={reloadPageTo}
                            selectedWidgetId={location.state?.selectedWidgetId}
                        />
                    )}
                />
                <Route
                    path={`${props.path}/:dashboardKey`}
                    render={({ history, location, match }) => (
                        <CustomDashboardLayout
                            dashboardConfiguration={JSON.parse(
                                location.state?.dashboardConfiguration ?? null
                            )}
                            dashboardKey={match.params.dashboardKey}
                            hasPendingChanges={
                                location.state?.hasPendingChanges
                            }
                            history={history}
                            isCreateMode={location.state?.isCreateMode}
                        />
                    )}
                />
            </Switch>
        </DashboardContext.Provider>
    );
}

CustomDashboardRoutes.propTypes = {
    assets: PropTypes.instanceOf(Object),
    baseName: PropTypes.string.isRequired,
    customizations: PropTypes.instanceOf(Object),
    favoriteUtilities: PropTypes.instanceOf(Object).isRequired,
    menuUtilities: PropTypes.instanceOf(Object).isRequired,
    path: PropTypes.string.isRequired,
    uriConstants: PropTypes.instanceOf(Object).isRequired,
};
